import React, { useState } from 'react';

interface DateTimePickerProps {
  initialDate: Date | null;
  dateTitle?: string | null;
  onDateChange: (date: Date | null) => void;
  id?: string | null;
  disabled?: boolean | null;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  initialDate,
  dateTitle,
  onDateChange,
  id,
  disabled
}) => {
  const localHours = initialDate?.getHours() ?? 0;
  const localMinutes = initialDate?.getMinutes() ?? 0;
  const localSeconds = initialDate?.getSeconds() ?? 0;

  const [selectedDate, setSelectedDate] = useState<string | null>(
    initialDate ? initialDate.toISOString().split('T')[0] : null
  );
  const [selectedTime, setSelectedTime] = useState<string | null>(
    initialDate
      ? `${localHours.toString().padStart(2, '0')}:${localMinutes.toString().padStart(2, '0')}:${localSeconds.toString().padStart(2, '0')}`
      : null
  );

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
    const combinedDateTime =
      newDate && selectedTime ? new Date(`${newDate}T${selectedTime}`) : null;
    onDateChange(combinedDateTime);
  };

  const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newTime = event.target.value;
    setSelectedTime(newTime);
    const combinedDateTime =
      selectedDate && newTime ? new Date(`${selectedDate}T${newTime}`) : null;
    onDateChange(combinedDateTime);
  };

  return (
    <div>
      <div className="field">
        <label htmlFor={id ? `${id}-date-picker` : 'date-picker'}>
          {`${dateTitle ? dateTitle + ' ' : ''}`}date
        </label>
        <input
          type="date"
          id={id ? `${id}-date-picker` : 'date-picker'}
          value={selectedDate || ''}
          onChange={handleDateChange}
          disabled={disabled ?? false}
        />
      </div>
      <div className="field">
        <label htmlFor={id ? `${id}-time-picker` : 'time-picker'}>
          {`${dateTitle ? dateTitle + ' ' : ''}`}time
        </label>
        <input
          type="time"
          id={id ? `${id}-time-picker` : 'time-picker'}
          value={selectedTime || ''}
          onChange={handleTimeChange}
          disabled={disabled ?? false}
        />
      </div>
    </div>
  );
};

export default DateTimePicker;
